@if (active$ | async) {
    <app-wizard-step [title]="title" data-test="step-auth">
        @if ((canGoNext$ | async) === false) {
            <app-signin-form
                [title]="'GENERAL.TITLE.ENTER_CREDENTIALS' | translate"
                (authorized)="onAuthorized($event)"
                [requiredRoles]="['supervisor']"
            />
        }
        @if (canGoNext$ | async) {
            <priva-notification status="Success" data-test="confirmation-auth-success"
                >{{ 'SETUP.STEP_4.SUCCESS_AUTHENTICATED' | translate }}
            </priva-notification>
        }
    </app-wizard-step>
}
